export default {
    BASE_MENU_WIDTH: 350,
    DEVELOPERS_MENU_WIDTH: 300
};
